import { render, staticRenderFns } from "./SummariesList.vue?vue&type=template&id=4442e535"
import script from "./SummariesList.vue?vue&type=script&lang=js"
export * from "./SummariesList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src2296946445/src/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4442e535')) {
      api.createRecord('4442e535', component.options)
    } else {
      api.reload('4442e535', component.options)
    }
    module.hot.accept("./SummariesList.vue?vue&type=template&id=4442e535", function () {
      api.rerender('4442e535', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/modules/summaries/components/SummariesList.vue"
export default component.exports